export default __webpack_public_path__ + "static/media/processing_payment.38820c5f.gif";